import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: theme.palette.primary.main,
    width: 18,
    height: 18,
  },
  label: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.primary.main,
  },
  description: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1.5),
  },
  linkRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  linkInput: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
    '& .MuiOutlinedInput-input': {
      fontSize: 12,
      padding: theme.spacing(1, 1.5),
    },
  },
  copyButton: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
}))

export default useStyles
